import * as React from 'react';
import { Chip } from '@mui/material';

// Small "Online" / "In person" indicator — used anywhere we show who's
// checked in to an event (the check-in list, Mingle pairings).
export const InPersonBadge = ({ isInPerson }) => (
  <Chip
    size="small"
    label={isInPerson ? '📍 In person' : '💻 Online'}
    sx={{
      height: 20,
      fontSize: 11,
      fontWeight: 700,
      background: isInPerson ? 'rgba(0,128,38,0.12)' : 'rgba(0,0,0,0.06)',
      color: isInPerson ? '#008026' : 'text.secondary',
    }}
  />
);
